import React, {
  Fragment,
  useContext,
  useEffect,
  useState,
  useRef,
} from "react";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import FormControlLabel from "@mui/material/FormControlLabel";
import Autocomplete from "@mui/material/Autocomplete";
import { AlertContext } from "../../../context/AlertContext";
import { ConfiguracionContext } from "../../../context/ConfiguracionContext";
import Fab from "@mui/material/Fab";
import AddIcon from "@mui/icons-material/Add";
import EditIcon from "@mui/icons-material/Edit";
import { Link, Redirect } from "react-router-dom";
import Spinner from "../Spinner";
import { AuthContext } from "../../../context/AuthContext";
import { ServiciosContext } from "../../../context/ServiciosContext";
import { Button } from "primereact/button";
import { Tooltip } from "primereact/tooltip";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import "../../../assets/css/DataTableDemo.css";
import "primereact/resources/themes/saga-blue/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import "../../../assets/css/CierreDialog.css";
import { Tag } from "primereact/tag";
import { InputText } from "primereact/inputtext";
import ButtonMui from "@mui/material/Button";
//import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";
import { Toast } from "primereact/toast";
import { Dialog } from "primereact/dialog";
import { Checkbox } from "primereact/checkbox";
import { ScrollPanel } from "primereact/scrollpanel";
import "../../../assets/css/ScrollPanelDemo.css";
import "../../../assets/css/DataTableDemo.css";
import "../../../assets/css/DialogDemo.css";
import ConsultaServicio from "../servicios/ConsultaServicio";
import NotasServicio from "../servicios/NotasServicio";
import { RadioButton } from "primereact/radiobutton";
import { alignment, defaultDataType } from "export-xlsx";
import ExcelExport from "export-xlsx";
import { jsPDF } from "jspdf";
import { ProgressBar } from "primereact/progressbar";
import hcOffcanvasNav from "hc-offcanvas-nav";
import { saveAs } from "file-saver";
import { Navigate, useNavigate } from "react-router-dom";
import Barra from "../Barra";

const agrupar = [
  {
    id: 1,
    nombre: "Base",
  },
  {
    id: 2,
    nombre: "ColorInicial",
  },
  {
    id: 3,
    nombre: "ColorFinal",
  },
  {
    id: 4,
    nombre: "Antecedente",
  },
  {
    id: 5,
    nombre: "Tratamiento",
  },
  {
    id: 6,
    nombre: "MotivoConsulta",
  },
  {
    id: 7,
    nombre: "Diagnostico",
  },
  {
    id: 8,
    nombre: "IDTitular",
  },
  {
    id: 9,
    nombre: "Documento",
  },
  {
    id: 10,
    nombre: "Fecha Tomado",
  },
  {
    id: 11,
    nombre: "Fecha Pasado",
  },
  {
    id: 12,
    nombre: "Fecha Salida",
  },
  {
    id: 13,
    nombre: "Fecha LLegada",
  },
  {
    id: 14,
    nombre: "Fecha Fin",
  },
];

export default function ListadosLaborales(props) {
  //const classes = useStyles();
  const [globalFilter, setGlobalFilter] = useState(null);
  const [selectedRow, setSelectedRow] = useState(null);
  let navigate = useNavigate();

  const exportColumns = [
    { title: "ID", dataKey: "id" },
    { title: "Nombre", dataKey: "nombre" },
    { title: "Habilitado", dataKey: "habilitado" },
  ];

  const [visibleFechas, setVisibleFechas] = useState(true);
  const [fechas, setFechas] = useState(null);
  const [visible, setVisible] = useState(false);
  const [visibleUpload, setVisibleUpload] = useState(false);
  const toast = useRef(null);
  const [file, setFile] = useState(null);
  const [filename, setFilename] = useState(null);
  const [servicio, setServicio] = useState(null);
  const [grupo, setGrupo] = useState(null);
  const [val, setVal] = useState(null);
  const [agrupado, setAgrupado] = useState(null);
  const [radio, setRadio] = useState("tomado");
  const [movilesDerivados, setMovilesDerivados] = useState(null);
  const [color, setColor] = useState(null);
  const [laboralCheck, setLaboralCheck] = useState(false);
  const [movilPropio, setMovilPropio] = useState(null);
  const [movilPropioCheck, setMovilPropioCheck] = useState(false);
  const [movilDerivado, setMovilDerivado] = useState(null);
  const [movilDerivadoCheck, setMovilDerivadoCheck] = useState(false);
  const [titularId, setTitularId] = useState(null);
  const [titularNombre, setTitularNombre] = useState(null);
  const [titularSeleccionado, setTitularSeleccionado] = useState(null);

  //Context

  const alertContext = useContext(AlertContext);
  const { mensajeAlerta } = alertContext;

  const authContext = useContext(AuthContext);
  const { state, usuarioAutenticado } = authContext;

  const configuracionContext = useContext(ConfiguracionContext);
  const {
    statusAcceso,
    statusAcceso2,
    colores,
    moviles,
    obtenerAcceso,
    obtenerAcceso2,
    obtenerColores,
    obtenerMoviles,
  } = configuracionContext;

  const serviciosContext = useContext(ServiciosContext);
  const {
    serviciosFinalizados,
    rows,
    filtrosListadosServicios,
    serviciosFinalizadosExcel,
    obtenerServiciosFinalizados,
    obtenerDatosTitulares,
    setRows,
  } = serviciosContext;

  useEffect(() => {
    if (state.usuario) {
      obtenerAcceso({ usuarioId: state.usuario.id, layout: "Listados" });
    }
  }, [state.id]);

  setTimeout(() => {
    if (statusAcceso === 400) {
      accesoDenegado();
    }
  }, 3000);

  function formatDate(input) {
    var datePart = input.match(/\d+/g),
      year = datePart[0],
      month = datePart[1],
      day = datePart[2];
    return day + "/" + month + "/" + year;
  }

  const groupBy = (prop) => (data) => {
    return data.reduce((dict, item) => {
      const { [prop]: _, ...rest } = item;
      dict[item[prop]] = [...(dict[item[prop]] || []), rest];
      return dict;
    }, {});
  };

  const calendar = (e) => {
    setVisibleFechas(true);
  };

  const exitClick = (e) => {
    onHideFechas();
    navigate(`/`);
  };

  const startClick = (e) => {
    setTimeout(() => {
      navigate(`/listadoslaborales`);
      setVisibleFechas(true);
    }, 2000);
  };

  const onHideFechas = (e) => {
    setVisibleFechas(false);
  };

  const aceptarFechas = async (exportType) => {
    //e.preventDefault();
    //Validar

    if (
      !fechas ||
      fechas.desde === undefined ||
      fechas.desde === null ||
      fechas.desde.trim() === ""
    ) {
      mensajeAlerta(
        "Listado de Servicios Laborales",
        "Fecha desde es necesaria !.",
        "error"
      );
      return;
    }

    if (
      !fechas ||
      fechas.hasta === undefined ||
      fechas.hasta === null ||
      fechas.hasta.trim() === ""
    ) {
      mensajeAlerta(
        "Listado de Servicios Laborales",
        "Fecha hasta es necesaria !.",
        "error"
      );
      return;
    }

    let fdesde = fechas.desde; //+ "T00:00:00";
    let fhasta = fechas.hasta; //+ "T23:59:59";

    var elem;

    await obtenerServiciosFinalizados({
      fdesde: fdesde,
      fhasta: fhasta,
      radio,
      titularSeleccionado,
      laboral: true,
    }).then((data) => {
      if (exportType === "excel") {
        elem = document.getElementById("expButtonExcel");
        elem.click();
      }
      if (exportType === "pdf") {
        elem = document.getElementById("expButtonPdf");
        elem.click();
      }
    });
    onHideFechas();
  };

  const accesoDenegado = () => {
    mensajeAlerta(
      "Accesos",
      "No tiene permiso para acceder a esta pantalla !.",
      "error"
    );
    exitClick();
    return;
  };

  const exportExcel = () => {
    if (serviciosFinalizadosExcel && serviciosFinalizadosExcel.length > 0) {
      import("xlsx").then((xlsx) => {
        const worksheet = xlsx.utils.json_to_sheet(serviciosFinalizadosExcel);
        const workbook = {
          Sheets: { data: worksheet },
          SheetNames: ["data"],
        };
        const excelBuffer = xlsx.write(workbook, {
          bookType: "xlsx",
          type: "array",
        });
        saveAsExcelFile(excelBuffer, "serviciosLaborales");
      });
    }
  };

  const saveAsExcelFile = (buffer, fileName) => {
    import("file-saver").then((FileSaver) => {
      let EXCEL_TYPE =
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
      let EXCEL_EXTENSION = ".xlsx";
      const data = new Blob([buffer], {
        type: EXCEL_TYPE,
      });
      saveAs(
        data,
        fileName + "_export_" + new Date().getTime() + EXCEL_EXTENSION
      );
    });

    startClick();
  };

  const exportPdf = () => {
    if (serviciosFinalizadosExcel && serviciosFinalizadosExcel.length > 0) {
      let PDF_EXTENSION = ".pdf";
      let fecha = new Date();

      const campo = agrupar[8 - 1].nombre; // id titular

      const result = Object.entries(
        groupBy(campo)(serviciosFinalizadosExcel)
      ).map(([key, value]) => ({ id: key, datos: value }));

      //pdf.text(`Hello world`, pdf.internal.pageSize.getWidth() / 2, 20, { align: 'center'} );

      //console.log(result);

      //doc.setFontSize(8);
      let row;

      for (var i = 0; i < result.length; i++) {
        row = 20;

        const doc = new jsPDF();

        doc.setFontSize(9);
        doc.text(
          "Servicios Laborales desde el " +
            formatDate(fechas.desde) +
            " Hasta el " +
            formatDate(fechas.hasta),
          10,
          10
        );

        doc.text(
          fecha.getDate() +
            "/" +
            (fecha.getMonth() + 1) +
            "/" +
            fecha.getFullYear() +
            "  " +
            fecha.getHours() +
            ":" +
            (fecha.getMinutes() < 10
              ? "0" + fecha.getMinutes()
              : fecha.getMinutes()),
          150,
          10
        );

        doc.text(
          "Empresa: " + result[i].datos[0].NombreTitular + " - " + result[i].id,
          10,
          row,
          "left",
          "middle"
        );
        row = row + 5;
        doc.line(10, row, 200, row);
        row = row + 5;
        for (var j = 0; j < result[i].datos.length; j++) {
          doc.text(
            "Tomado: " + result[i].datos[j].FechaTomado,
            10,
            row,
            "left",
            "middle"
          );
          doc.text(
            "LLegada: " + result[i].datos[j].FechaLlegada,
            80,
            row,
            "left",
            "middle"
          );
          if (result[i].datos[j].Movil !== null) {
            doc.text(
              "Móvil: " + result[i].datos[j].Movil,
              150,
              row,
              "left",
              "middle"
            );
          } else {
            doc.text(
              "Móvil: " + result[i].datos[j].Derivado,
              150,
              row,
              "left",
              "middle"
            );
          }

          row = row + 5;
          doc.text(
            "Afiliado: " + result[i].datos[j].NombreAfiliado.substring(0, 25),
            10,
            row,
            "left",
            "middle"
          );
          doc.text(
            "Edad: " + result[i].datos[j].Edad.toString(),
            80,
            row,
            "left",
            "middle"
          );
          doc.text(
            "Sexo: " + result[i].datos[j].Sexo.toString(),
            95,
            row,
            "left",
            "middle"
          );
          doc.text(
            "Documento: " + result[i].datos[j].Documento.toString(),
            110,
            row,
            "left",
            "middle"
          );
          doc.text(
            "Teléfono: " + result[i].datos[j].Telefono.toString(),
            150,
            row,
            "left",
            "middle"
          );

          row = row + 5;
          doc.text(
            "Domicilio: " + result[i].datos[j].Domicilio,
            10,
            row,
            "left",
            "middle"
          );

          row = row + 5;
          doc.text(
            "Diagnóstico: " +
              (result[i].datos[j].Diagnostico !== null
                ? result[i].datos[j].Diagnostico.substring(0, 30)
                : ""),
            10,
            row,
            "left",
            "middle"
          );
          doc.text(
            "Trabaja: " +
              (result[i].datos[j].trabaja !== null &&
              result[i].datos[j].trabaja === true
                ? formatDate(result[i].datos[j].FechaTrabaja)
                : ""),
            120,
            row,
            "left",
            "middle"
          );
          doc.text(
            "Citado: " +
              (result[i].datos[j].citado !== null &&
              result[i].datos[j].citado === true
                ? formatDate(result[i].datos[j].FechaCitado)
                : ""),
            150,
            row,
            "left",
            "middle"
          );
          row = row + 5;
          doc.text(
            "Detalle Diagnóstico: " +
              (result[i].datos[j].DetalleDiagnostico !== null
                ? result[i].datos[j].DetalleDiagnostico
                : ""),
            10,
            row,
            {
              maxWidth: 190,
              align: "left",
            }
          );

          row = row + 20;
          doc.line(10, row, 200, row);
          row = row + 5;

          if (row >= 260) {
            doc.addPage();
            //doc.setFontSize(9);
            doc.text(
              "Servicios Laborales desde el " +
                formatDate(fechas.desde) +
                " Hasta el " +
                formatDate(fechas.hasta),
              10,
              10
            );

            doc.text(
              fecha.getDate() +
                "/" +
                (fecha.getMonth() + 1) +
                "/" +
                fecha.getFullYear() +
                "  " +
                fecha.getHours() +
                ":" +
                (fecha.getMinutes() < 10
                  ? "0" + fecha.getMinutes()
                  : fecha.getMinutes()),
              150,
              10
            );
            //doc.setFontSize(8);
            row = 20;
          }
        }
        row = row + 4;
        doc.text("Cantidad de Servicios " + result[i].datos.length, 100, row);

        doc.save(result[i].id + PDF_EXTENSION);
      }
    }
    startClick();
  };

  const renderHeaderFechas = () => {
    return (
      <div>
        <Tag value="Listado de Servicios Laborales"></Tag>
      </div>
    );
  };

  const renderFooterFechas = () => {
    return (
      <div>
        <button
          id="expButtonExcel"
          type="button"
          onClick={(e) => {
            exportExcel();
          }}
          style={{ visibility: "hidden" }}
        >
          Export Excel
        </button>
        <button
          id="expButtonPdf"
          type="button"
          onClick={(e) => {
            exportPdf();
          }}
          style={{ visibility: "hidden" }}
        >
          Export Pdf
        </button>

        <Button
          type="button"
          icon="pi pi-file-excel"
          onClick={(e) => {
            aceptarFechas("excel");
            //exportExcel();
          }}
          className="p-button-success p-mr-2"
          data-pr-tooltip="XLS"
        >
          Excel
        </Button>
        <Button
          type="button"
          icon="pi pi-file-pdf"
          onClick={(e) => {
            aceptarFechas("pdf");
          }}
          className="p-button-warning p-mr-2"
          data-pr-tooltip="PDF"
          style={{ marginRight: "1em" }}
        >
          PDF
        </Button>
        {/*
        <ButtonMui
          onClick={aceptarFechas}
          color="primary"
          type="button"
          fullWidth
          variant="contained"
          startIcon={<CheckIcon />}
        >
          Aceptar
        </ButtonMui>
        */}
        <ButtonMui
          onClick={exitClick}
          color="secondary"
          type="button"
          fullWidth
          variant="contained"
          startIcon={<CloseIcon />}
          autoFocus
        >
          Cancelar
        </ButtonMui>
      </div>
    );
  };

  const buscarAfiliados = () => {
    if (titularNombre !== null && titularNombre !== "") {
      obtenerDatosTitulares({
        opcion: "Apellido y nombre",
        texto: titularNombre,
      });
    }
    if (titularId !== null && titularId !== "") {
      obtenerDatosTitulares({
        opcion: "Número de socio",
        texto: titularId,
      });
    }
  };

  //console.log(moviles);
  //console.log(serviciosFinalizadosExcel);

  return (
    <Fragment>
      <Barra />
      <Toast ref={toast} />
      {statusAcceso === 0 || statusAcceso === 400 ? <Spinner /> : null}
      {statusAcceso === 200 ? (
        <Fragment>
          <Dialog
            header={renderHeaderFechas()}
            className="cierre-dialog"
            visible={visibleFechas}
            closable={false}
            footer={renderFooterFechas()}
            breakpoints={{ "960px": "75vw" }}
            style={{ width: "70vw", paddingBottom: "0" }}
            position="top"
          >
            <Grid container spacing={3} style={{ marginTop: "1vw" }}>
              <Grid
                container
                spacing={3}
                style={{ marginTop: "1vw", marginLeft: "1vw" }}
              >
                <label htmlFor="tomado">F. Tomado</label>
                <RadioButton
                  inputId="tomado"
                  value="tomado"
                  name="fecha"
                  onChange={(e) => setRadio(e.value)}
                  checked={radio === "tomado"}
                  style={{ marginTop: "0.2vw", marginLeft: "0.5vw" }}
                />
                <label style={{ marginLeft: "1vw" }} htmlFor="pasado">
                  F. Pasado
                </label>
                <RadioButton
                  inputId="pasado"
                  value="pasado"
                  name="fecha"
                  onChange={(e) => setRadio(e.value)}
                  checked={radio === "pasado"}
                  style={{ marginTop: "0.2vw", marginLeft: "0.5vw" }}
                />
                <label style={{ marginLeft: "1vw" }} htmlFor="salida">
                  F. Salida
                </label>
                <RadioButton
                  inputId="salida"
                  value="salida"
                  name="fecha"
                  onChange={(e) => setRadio(e.value)}
                  checked={radio === "salida"}
                  style={{ marginTop: "0.2vw", marginLeft: "0.5vw" }}
                />
                <label style={{ marginLeft: "1vw" }} htmlFor="llegada">
                  F. Llegada
                </label>
                <RadioButton
                  inputId="llegada"
                  value="llegada"
                  name="fecha"
                  onChange={(e) => setRadio(e.value)}
                  checked={radio === "llegada"}
                  style={{ marginTop: "0.2vw", marginLeft: "0.5vw" }}
                />
                <label style={{ marginLeft: "1vw" }} htmlFor="fin">
                  F. Fin
                </label>
                <RadioButton
                  inputId="fin"
                  value="fin"
                  name="fecha"
                  onChange={(e) => setRadio(e.value)}
                  checked={radio === "fin"}
                  style={{ marginTop: "0.2vw", marginLeft: "0.5vw" }}
                />
              </Grid>

              <Grid item xs={12} md={4}>
                <TextField
                  id="desde"
                  label="Desde"
                  type="datetime-local"
                  fullWidth
                  variant="outlined"
                  //onKeyDown={handleEnter}
                  value={fechas && fechas.desde ? fechas.desde : null}
                  required
                  InputLabelProps={{
                    shrink: true,
                  }}
                  onChange={(e) => {
                    setFechas({
                      ...fechas,
                      desde: e.target.value,
                    });
                  }}
                />
              </Grid>
              <Grid item xs={12} md={4}>
                <TextField
                  id="hasta"
                  label="Hasta"
                  type="datetime-local"
                  fullWidth
                  variant="outlined"
                  //onKeyDown={handleEnter}
                  value={fechas && fechas.hasta ? fechas.hasta : null}
                  required
                  InputLabelProps={{
                    shrink: true,
                  }}
                  onChange={(e) => {
                    setFechas({
                      ...fechas,
                      hasta: e.target.value,
                    });
                  }}
                />
              </Grid>
              <Grid
                item
                xs={12}
                md={4}
                style={{ paddingLeft: 0, marginTop: "0em" }}
              />

              <Grid item xs={12} md={2}>
                <TextField
                  id="titular"
                  label="ID Titular"
                  fullWidth
                  variant="outlined"
                  type="number"
                  value={titularId ? titularId : ""}
                  disabled={titularNombre !== null && titularNombre !== ""}
                  //onKeyDown={handleEnter}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  onChange={(e) => {
                    setTitularId(e.target.value);
                    setTitularSeleccionado(null);
                    setRows(null);
                  }}
                />
              </Grid>

              <Grid item xs={12} md={4}>
                <TextField
                  id="razonSearch"
                  label="Apellido y Nombre o Razón Social"
                  fullWidth
                  variant="outlined"
                  value={titularNombre ? titularNombre : ""}
                  disabled={
                    titularId !== null && titularId !== "" && titularId !== 0
                  }
                  //onKeyDown={handleEnter}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  onChange={(e) => {
                    setTitularNombre(e.target.value);
                    setTitularSeleccionado(null);
                    setRows(null);
                  }}
                />
              </Grid>
              <Grid item xs={12} md={1}>
                <Button
                  icon="pi pi-search"
                  className="p-button-rounded p-button-success"
                  onClick={() => buscarAfiliados()}
                />
              </Grid>

              <Grid item xs={12} md={5}>
                <Autocomplete
                  id="razon"
                  fullWidth
                  options={rows}
                  disabled={!rows}
                  noOptionsText={"No hay opciones"}
                  style={{ marginLeft: ".8vw", color: "green" }}
                  //defaultValue={grupo ? agrupar[grupo - 1] : null}
                  value={titularSeleccionado}
                  disablePortal
                  getOptionLabel={(option) => option.nombre_razonsocial}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Seleccione el Afiliado"
                      variant="outlined"
                    />
                  )}
                  onChange={(event, value) => {
                    if (value) {
                      setTitularSeleccionado(value);
                      setTitularId(value.id_titular);
                      setTitularNombre(null);
                    } else {
                      setTitularSeleccionado(null);
                    }
                  }}
                />
              </Grid>

              {/*   
              <Grid
                item
                xs={12}
                md={12}
                style={{ paddingLeft: 0, marginTop: "0em" }}
              >
                {!rows &&
                ((titularId && titularId.length >= 4) ||
                  (titularNombre && titularNombre.length >= 3)) ? (
                  <ProgressBar
                    mode="indeterminate"
                    style={{ height: "6px" }}
                  ></ProgressBar>
                ) : null}
              </Grid>
                  */}
            </Grid>
          </Dialog>
        </Fragment>
      ) : null}
      <Grid item xs={12} sm={12}></Grid>
    </Fragment>
  );
}

/* class="MuiDataGrid-cell MuiDataGrid-cellLeft" */
